import classes from "./BookingDetailsSkeleton.module.css";
import { useNavigate } from "react-router-dom";

export const BookingDetailsSkeleton = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className={classes.container}>
            <header className={classes.header}>
                <div onClick={handleBack} className={classes.backButton}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 11 19" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 9.12355L8.99855 0.125L10.2006 1.32708L2.35773 9.16998L10.2486 17.7184L8.99941 18.8715L0.0172915 9.14084L0 9.12355Z" fill="white"/>
                    </svg>
                    <p className="mediumLarge">Zurück</p>
                </div>
                <div className={classes.skeletonStudioName}></div>
                <div className={classes.shareButton}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 15 20" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M7.2583 0L10.9611 3.71119L9.95414 4.70343L7.95893 2.70368V12.5396H6.54092V2.71625L4.54493 4.7119L3.53923 3.71844L7.2583 0ZM2.41092 7.55162C1.86699 7.55162 1.418 7.993 1.418 8.55279V17.0896C1.418 17.6494 1.86699 18.0908 2.41092 18.0908H12.0891C12.633 18.0908 13.082 17.6494 13.082 17.0896V8.55279C13.082 7.993 12.633 7.55162 12.0891 7.55162H9.72052V6.14239H12.0891C13.4275 6.14239 14.5 7.226 14.5 8.55279V17.0896C14.5 18.4164 13.4275 19.5 12.0891 19.5H2.41092C1.07254 19.5 0 18.4164 0 17.0896V8.55279C0 7.226 1.07254 6.14239 2.41092 6.14239H4.77948V7.55162H2.41092Z" fill="white"/>
                    </svg>
                    <p className="mediumLarge">Teilen</p>
                </div>
            </header>
            <div className={classes.content}>
                <div className={classes.cardContainer}>
                    <div className={classes.imageContainer}>
                        <div className={classes.skeletonImage} />
                        <div className={classes.textContainer}>
                            <div className={classes.skeletonText} />
                            <div className={classes.skeletonTextSmall} />
                        </div>
                    </div>
                    <div className={classes.horizontalLine} />
                    <div className={classes.section}>
                        <div className={classes.skeletonText} />
                        <div className={classes.skeletonTextLarge} />
                    </div>
                    <div className={classes.horizontalLine} />
                    <div className={classes.section}>
                        <div className={classes.skeletonText} />
                        <div className={classes.skeletonTextLarge} />
                        <div className={classes.skeletonButton} />
                    </div>
                    <div className={classes.horizontalLine} />
                    <div className={classes.section}>
                        <div className={classes.skeletonText} />
                        <div className={classes.skeletonTextLarge} />
                    </div>
                </div>
                <div className={classes.mainContainer}>
                    <div className={classes.hostSection}>
                        <div className={classes.skeletonText} />
                        <div className={classes.hostInfo}>
                            <div className={classes.skeletonAvatar} />
                            <div className={classes.hostTextContainer}>
                                <div className={classes.skeletonTextLarge} />
                                <div className={classes.skeletonTextSmall} />
                            </div>
                        </div>
                        <div className={classes.skeletonButton} />
                    </div>
                    <div className={classes.horizontalLine} />
                    <div className={classes.section}>
                        <div className={classes.skeletonText} />
                        <div className={classes.skeletonTextLarge} />
                        <div className={classes.skeletonTextLarge} />
                        <div className={classes.skeletonButton} />
                    </div>
                    <div className={classes.horizontalLine} />
                    <div className={classes.section}>
                        <div className={classes.skeletonText} />
                        <div className={classes.skeletonTextLarge} />
                        <div className={classes.skeletonTextLarge} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingDetailsSkeleton;